import React, { useEffect, useState } from 'react'
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'
import { toast } from 'react-toastify'
import { Divider } from '@mui/material'
import L from 'leaflet'
import PropTypes from 'prop-types'

import DeliveryAPI from '../../../../../../api/orbitV1/DeliveryAPI'
import OneMapAPI from '../../../../../../api/orbitV1/OneMapAPI'
import { ONE_MAP } from '../../../../../../constants/maps'

/**
 *
 * @param {Object} props
 * @param {import('../../../apis/order.type').OrderModel} props.order
 * @param {boolean} props.hasValidState
 */
function OrderDeliveryMap(props) {
  const mapCenter = [1.3388, 103.815]
  const circlesCoord = [1.28, 103.8204]
  const markers = []
  const bounds = []
  const [deliveryCoord, setDeliveryCoord] = useState([0, 0])
  const [delivery, setDelivery] = useState({})
  const LeafIcon = L.Icon.extend({
    options: {}
  })
  const sourceIcon = new LeafIcon({
    iconUrl: ONE_MAP.markerUrl.source,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  })
  const destIcon = new LeafIcon({
    iconUrl: ONE_MAP.markerUrl.destination,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  })

  const getDelivery = async (orderNo) => {
    let deliveryData
    try {
      deliveryData = await DeliveryAPI.getDelivery(orderNo)
      setDelivery(deliveryData.data)
    } catch (error) {
      toast.error(
        'Error loading delivery. Please contact your admin for support.'
      )
    }

    try {
      const deliveryCoords = await OneMapAPI.getCoords(
        deliveryData.data.postalCode
      )
      setDeliveryCoord([
        parseFloat(deliveryCoords.data.results[0]?.LATITUDE),
        parseFloat(deliveryCoords.data.results[0]?.LONGITUDE)
      ])
    } catch (error) {
      toast.error(
        'Error loading the map. Please contact your admin for support.'
      )
    }
  }

  useEffect(() => {
    getDelivery(props.order.orderNo)
  }, [])

  markers.push({
    position: circlesCoord,
    icon: sourceIcon,
    popupText: 'Circles.life The Best Telco in Singapore.'
  })

  if (delivery) {
    markers.push({
      position: deliveryCoord,
      icon: destIcon,
      popupText: `${delivery.address + ', ' + delivery.postalCode}`
    })

    markers.map((m) => {
      return bounds.push(m.position)
    })
  }
  if (!props.hasValidState) {
    return <div>This order has not been scheduled for delivery.</div>
  }

  return (
    <>
      <Divider />
      <MapContainer scrollWheelZoom zoom={12} center={mapCenter}>
        <TileLayer attribution={ONE_MAP.attribution} url={ONE_MAP.url.night} />
        {markers.map((mark) => (
          <Marker position={mark.position} icon={mark.icon} key={mark.position}>
            <Popup>{mark.popupText}</Popup>
          </Marker>
        ))}
      </MapContainer>
    </>
  )
}

OrderDeliveryMap.propTypes = {
  order: PropTypes.object,
  hasValidState: PropTypes.bool
}

export default OrderDeliveryMap
